import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NavigationState {
    isMenuOpen: boolean;
    isScannerOpen: boolean;
    previousRoute: string | null;
}

const initialState: NavigationState = {
    isMenuOpen: false,
    isScannerOpen: false,
    previousRoute: null,
};

export const navigationSlice = createSlice({
    name: 'navigation',
    initialState,
    reducers: {
        toggleMenu: (state) => {
        state.isMenuOpen = !state.isMenuOpen;
        },
        closeMenu: (state) => {
        state.isMenuOpen = false;
        },
        openMenu: (state) => {
        state.isMenuOpen = true;
        },
        toggleScanner: (state) => {
        state.isScannerOpen = !state.isScannerOpen;
        },
        openScanner: (state) => {
        state.isScannerOpen = true;
        },
        closeScanner: (state) => {
        state.isScannerOpen = false;
        },
        setPreviousRoute: (state, action: PayloadAction<string | null>) => {
        state.previousRoute = action.payload;
        },
    },
});

export const {
    toggleMenu,
    closeMenu,
    openMenu,
    toggleScanner,
    openScanner,
    closeScanner,
    setPreviousRoute,
} = navigationSlice.actions;

export default navigationSlice.reducer; 